import { object } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { topic } from './shared/topic'
import { brandVoiceId, tone } from './shared/voiceTones'
import { count } from './shared/count'
import { links } from './shared/links'
import { avoid } from './shared/avoid'
import { Twitter } from 'blaze-ui/icons'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { includeImages } from './shared/includeImages'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { brandKitId } from './shared/brandKitId'
import { language } from './shared/language'
import { TextChannels } from '../../../constants'

const meta = {
  type: ChannelType.TweetThread,
  icon: Twitter,
  steps: ['Context', 'Generate Thread'],
  title: TextChannels[ChannelType.TweetThread].name,
  submitLabel: 'Generate Thread',
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183792/Home%20Card%20Previews/b759phz9eh9j7bnkxqrw.png',
}

const fields = {
  topic: topic.meta({ label: 'What is the topic of your Twitter thread?', generationType: meta.type }),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  source_material_ids: sourceMaterialIds,
  tone,
  language,
  include_images: includeImages.meta({
    description: 'An image will make your thread far more engaging and attention grabbing',
  }),
  count: count.default(6).min(1).max(6).meta({ label: 'How many tweets do you want in this thread? (Max 6)' }),
  links: links.meta({ collapsible: true }),
  avoid: avoid.meta({ collapsible: true }),
}

export const TwitterThreadSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>

export const TwitterThreadMultiStepSchema: MultiStepSchema<ChannelType.TweetThread> = {
  steps: [
    TwitterThreadSchema.omit(['include_images']).meta({
      title: 'Purpose & Goals',
      submitLabel: 'Select Images',
    }) as StepSchema,
    SelectImages.meta({ submitLabel: 'Generate Thread', type: meta.type }) as StepSchema,
  ],
  meta: {
    ...meta,
    type: ChannelType.TweetThread,
    channel: ChannelType.TweetThread,
  },
}
